import { mergeMap, switchMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetParamsAndResolver } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { MarkupAction } from '../markup.action';
import { MarkupTranslator } from '../markup.translator';

type IDependencies = IClientApiDependencySegment;

export const updateMarkupEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetParamsAndResolver(MarkupAction.update.started),
  switchMap(({ params, resolve, reject }) => {
    const { profileId, markup } = params;
    const { symbolId } = markup;

    return dependencies.api.updateMarkup({ profileId, symbolId, ...MarkupTranslator.toApi(markup) }).pipe(
      mergeMap(() => {
        resolve?.();
        return [
          MarkupAction.update.done({ params }),
        ];
      }),
      catchApiError((error) => {
        const isHandled = reject?.(error.errorCode, error.description, error.params);
        return [
          MarkupAction.update.failed({ params, error }),
          ...(isHandled ? [] : [createApiErrorNotification(error)]),
        ];
      }),
    );
  }),
);
